export default "__VITE_ASSET__DVvl2FoY__"